import { SettlementSchedule } from './collateral/SettlementSchedule';
export const Collateral = {
    settlement_schedule: SettlementSchedule,
};
